import { Gtag } from "@/plugins/integrations/gtag.client"

export const MFM_EVENT_ALIAS = "mfm2026"
export const MFM_API_CONFIG = { params: { event: MFM_EVENT_ALIAS } }
export const MFM_INVITE_TOKEN = "8v6a9ccn3u"
export const MFM_ADULT_CHECK_DATE = "2026-09-09"
export const MFM_CONTEST_INVITE_TOKEN = "jltkx0q9z7"

type Localized_ = Omit<Localized, "current">

interface ProgramSession {
  title: Localized_
  text: Localized_
  cover: string
}

interface ProgramGroup {
  title: Localized_
  sessions: ProgramSession[]
}

const PROGRAM_IMG_BASE = "/img/mfm/program"

export const MFM_PROGRAM: ProgramGroup[] = [
  {
    title: {
      ru: "Знание-программа",
      en: "Knowledge Track",
    },
    sessions: [
      {
        title: {
          ru: "Лекции",
          en: "Lectures",
        },
        text: {
          ru: "Живые встречи, на&nbsp;которых эксперты делятся знаниями, опытом и&nbsp;вдохновляющими историями. Вы&nbsp;открываете новые смыслы, задаёте вопросы и&nbsp;находите идеи, которые можно применить в&nbsp;жизни.",
          en: "Live sessions where experts share knowledge, experience, and inspiring stories. Discover new ideas, ask questions, and find insights you can apply in&nbsp;your own life.",
        },
        cover: `${PROGRAM_IMG_BASE}/lectures.webp`,
      },
      {
        title: {
          ru: "Сессии",
          en: "Sessions",
        },
        text: {
          ru: "Практические встречи, где участники вместе ищут решения, обмениваются опытом и&nbsp;создают конкретные идеи. Это пространство для продуктивного общения, в&nbsp;котором рождаются договорённости, проекты и&nbsp;новые смыслы.",
          en: "Hands-on sessions where participants work together to&nbsp;find solutions, exchange experiences, and develop concrete ideas. It&rsquo;s a&nbsp;space for productive dialogue where agreements, projects, and new ideas take shape.",
        },
        cover: `${PROGRAM_IMG_BASE}/sessions.webp`,
      },
      {
        title: {
          ru: "Ток-шоу",
          en: "Talk Shows",
        },
        text: {
          ru: "Открытый разговор на&nbsp;актуальные темы с&nbsp;яркими гостями и&nbsp;живой аудиторией. Мнения, эмоции и&nbsp;неожиданные повороты дискуссии создают атмосферу, в&nbsp;которой каждый чувствует себя частью большого диалога.",
          en: "Open conversations on&nbsp;current topics with distinguished guests and a&nbsp;live audience. Different perspectives, emotions, and unexpected turns in&nbsp;the discussion create an&nbsp;atmosphere where everyone feels part of&nbsp;a&nbsp;larger dialogue.",
        },
        cover: `${PROGRAM_IMG_BASE}/talkshow.webp`,
      },
    ],
  },

  {
    title: {
      ru: "Молодёжь в культуре",
      en: "Youth in Culture",
    },
    sessions: [
      {
        title: {
          ru: "Иммерсивные шоу",
          en: "Immersive shows",
        },
        text: {
          ru: "Вы&nbsp;не&nbsp;просто зритель, вы&nbsp;активный участник! Интерактивное представление, в&nbsp;котором грань между сценой и&nbsp;зрителями стирается благодаря свету, звуку и&nbsp;визуальным эффектам.",
          en: "You&rsquo;re not just a&nbsp;spectator, you&rsquo;re an&nbsp;active participant! An&nbsp;interactive experience where the line between the stage and audience blurs through light, sound, and visual effects.",
        },
        cover: `${PROGRAM_IMG_BASE}/immersive-shows.webp`,
      },
      {
        title: {
          ru: "Арт-перфомансы",
          en: "Art performances",
        },
        text: {
          ru: "Симфония цветов, огней и&nbsp;движения. Уличное искусство, уникальные испытания и&nbsp;увлекательные представления, которые вдохновляют на&nbsp;творчество и&nbsp;вызывают чувство единства.",
          en: "A&nbsp;symphony of&nbsp;colors, lights, and movement. Street art, unique challenges, and fascinating performances that inspire creativity and evoke a&nbsp;sense of&nbsp;unity.",
        },
        cover: `${PROGRAM_IMG_BASE}/art-performances.webp`,
      },
      {
        title: {
          ru: "Креативные лаборатории",
          en: "Creative labs",
        },
        text: {
          ru: "Присоединяйтесь к&nbsp;нам и&nbsp;творите! Пространства, где участники могут не&nbsp;только придумывать креативные идеи, но&nbsp;и&nbsp;воплощать их&nbsp;в&nbsp;жизнь.",
          en: "It&rsquo;s time to&nbsp;join&nbsp;us and create! Spaces where participants can not only come up&nbsp;with creative ideas, but also put them into action.",
        },
        cover: `${PROGRAM_IMG_BASE}/creative-labs.webp`,
      },
      {
        title: {
          ru: "Концертные программы",
          en: "Concert Programs",
        },
        text: {
          ru: "Живая музыка и&nbsp;движение, от&nbsp;которых теплеет на&nbsp;душе. Вы&nbsp;отправляетесь в&nbsp;большое эмоциональное путешествие, где каждый звук рассказывает историю.",
          en: "Live music and energy that warm the heart. Embark on&nbsp;an&nbsp;emotional journey where every sound tells a&nbsp;story.",
        },
        cover: `${PROGRAM_IMG_BASE}/concert.webp`,
      },
      {
        title: {
          ru: "Шоу-программы",
          en: "Show Programs",
        },
        text: {
          ru: "Театрализованные шоу, постановки и&nbsp;национальные представления, где музыка, танец и&nbsp;свет сливаются в&nbsp;яркое, тёплое действо. Вы&nbsp;&mdash; часть большого праздника, который согревает и&nbsp;остаётся в&nbsp;сердце надолго.",
          en: "Theatrical shows, performances, and national showcases where music, dance, and light come together in&nbsp;a&nbsp;vibrant and welcoming show. You are part of&nbsp;a&nbsp;big celebration that warms the heart and stays with you long after it&rsquo;s over.",
        },
        cover: `${PROGRAM_IMG_BASE}/show.webp`,
      },
    ],
  },

  {
    title: {
      ru: "Велнес-программа",
      en: "Wellness Track",
    },
    sessions: [
      {
        title: {
          ru: "Спортивные шоу",
          en: "Sports shows",
        },
        text: {
          ru: "Зрелищные соревнования и&nbsp;выступления, которые вдохновляют и&nbsp;доказывают, что всё возможно.",
          en: "Spectacular competitions and performances that inspire and prove that anything is&nbsp;possible.",
        },
        cover: `${PROGRAM_IMG_BASE}/sports-shows.webp`,
      },
      {
        title: {
          ru: "Активный отдых",
          en: "Outdoor activities",
        },
        text: {
          ru: "Утренняя зарядка с&nbsp;чемпионами, тренировки на&nbsp;свежем воздухе и&nbsp;дружеские спортивные турниры для всех желающих.",
          en: "Morning exercises with champions, outdoor workouts and friendly sports tournaments for everyone.",
        },
        cover: `${PROGRAM_IMG_BASE}/outdoor-activities.webp`,
      },
      {
        title: {
          ru: "Академия спорта",
          en: "Sports Academy",
        },
        text: {
          ru: "Уникальная среда для роста через практику: воркшопы с&nbsp;чемпионами, мастер-классы и&nbsp;профессиональные сессии, где теория встречается с&nbsp;личным опытом спортсменов.",
          en: "It&nbsp;is&nbsp;a&nbsp;unique environment for growth through practice: workshops with champions, master classes and professional sessions where theory meets the personal experience of&nbsp;athletes.",
        },
        cover: `${PROGRAM_IMG_BASE}/sports-academy.webp`,
      },
    ],
  },

  {
    title: {
      ru: "Добрая программа",
      en: "Good Deeds Track",
    },
    sessions: [
      {
        title: {
          ru: "Экологические акции",
          en: "Environmental Initiatives",
        },
        text: {
          ru: "Полезные форматы, которые меняют мир вокруг здесь и&nbsp;сейчас. Высадка деревьев, субботники, благотворительные экскурсии&nbsp;&mdash; простые дела, которые объединяют и&nbsp;дарят чувство причастности.",
          en: "Hands-on activities that are changing the world right here and now. Simple actions like tree planting, community cleanups, and charity tours bring people together and create a&nbsp;sense of&nbsp;belonging.",
        },
        cover: `${PROGRAM_IMG_BASE}/ecoactions.webp`,
      },
      {
        title: {
          ru: "Добрые<br>минуты",
          en: "Good<br>Minutes",
        },
        text: {
          ru: "Каждый день одна минута Фестиваля будет самой доброй. Поучаствовать сможет каждый: обнять друга, позвонить родителям, сказать добрые слова поддержки рядом стоящему человеку.",
          en: "Each Festival day will dedicate one minute to&nbsp;kindness. Anyone can participate. Hug a&nbsp;friend, call your parents, or&nbsp;offer a&nbsp;few words of&nbsp;support to&nbsp;someone nearby.",
        },
        cover: `${PROGRAM_IMG_BASE}/good-mitutes.webp`,
      },
      {
        title: {
          ru: "Арт-объект Маяк",
          en: "Lighthouse Art Installation",
        },
        text: {
          ru: "Пространство, где каждый может оставить своё доброе намерение. Участники и&nbsp;медиа-гости закрепляют обещанное наклейкой, создавая единый символ Фестиваля&nbsp;&mdash; маяк, собранный из&nbsp;тысяч тёплых обещаний.",
          en: "A&nbsp;space where everyone can leave a&nbsp;positive intention. Participants and media guests place a&nbsp;sticker next to&nbsp;their promise, creating a&nbsp;shared Festival symbol: a&nbsp;lighthouse made up&nbsp;of&nbsp;thousands of&nbsp;heartfelt promises.",
        },
        cover: `${PROGRAM_IMG_BASE}/lighthouse.webp`,
      },
    ],
  },

  {
    title: {
      ru: "Экскурсионная программа",
      en: "Excursion program",
    },
    sessions: [
      {
        title: {
          ru: "Знакомство с&nbsp;городом в&nbsp;пути",
          en: "Exploring the City Along the Way",
        },
        text: {
          ru: "Погружение в&nbsp;атмосферу Фестиваля начинается уже по&nbsp;дороге из&nbsp;аэропорта или с&nbsp;вокзала. Специальный аудиогид познакомит тебя с&nbsp;Екатеринбургом, концепцией Фестиваля и&nbsp;его ключевыми смыслами.",
          en: "Your immersion in&nbsp;the Festival atmosphere begins as&nbsp;soon as&nbsp;you leave the airport or&nbsp;train station. A&nbsp;special audio guide will introduce you to&nbsp;Ekaterinburg, the Festival concept, and its key ideas.",
        },
        cover: `${PROGRAM_IMG_BASE}/greetingcity.webp`,
      },
      {
        title: {
          ru: "Город молодёжи мира",
          en: "World Youth City",
        },
        text: {
          ru: "Маршрут по&nbsp;ключевым пространствам Фестиваля вместе с&nbsp;экскурсоводами&nbsp;&mdash; &laquo;проводниками смыслов&raquo;. Ты&nbsp;познакомишься с&nbsp;площадками, узнаешь, как они устроены, и&nbsp;увидишь главные точки притяжения Города молодежи мира.",
          en: "Explore the key spaces of&nbsp;the Festival with tour guides who serve as&nbsp;&ldquo;guides of&nbsp;meanings.&rdquo; You will discover the venues, learn how they are organized, and see the main hubs of&nbsp;World Youth City.",
        },
        cover: `${PROGRAM_IMG_BASE}/youthcity.webp`,
      },
      {
        title: {
          ru: "Знаковые места Екатеринбурга",
          en: "Ekaterinburg&rsquo;s Iconic Places",
        },
        text: {
          ru: "Автобусная экскурсия по&nbsp;главным достопримечательностям уральской столицы. Вместе с&nbsp;экскурсоводом ты&nbsp;увидишь разные грани города, почувствуешь его характер и&nbsp;узнаешь, как история и&nbsp;современность формируют его облик.",
          en: "Take a&nbsp;bus tour of&nbsp;the Ural capital&rsquo;s main landmarks. Along with your tour guide, you&rsquo;ll discover the city from different perspectives, experience its unique character, and learn how history and modern life have shaped its identity.",
        },
        cover: `${PROGRAM_IMG_BASE}/mainplaces.webp`,
      },
      {
        title: {
          ru: "Индустриальный Урал",
          en: "Industrial Urals",
        },
        text: {
          ru: "Тематические поездки на&nbsp;предприятия по&nbsp;направлениям интересов участников. В&nbsp;пути &laquo;проводник смыслов&raquo; расскажет, как развивается отрасль на&nbsp;Урале и&nbsp;в&nbsp;России, а&nbsp;на&nbsp;объекте ты&nbsp;познакомишься с&nbsp;реальными производственными процессами и&nbsp;технологиями.",
          en: "Take thematic trips to&nbsp;industrial enterprises based on&nbsp;your interests. A&nbsp;&ldquo;guide of&nbsp;meanings&rdquo; will accompany you along the way, explaining how industries are developing in&nbsp;the Urals and across Russia. At&nbsp;the site, you&rsquo;ll also get a&nbsp;firsthand look at&nbsp;real production processes and technology.",
        },
        cover: `${PROGRAM_IMG_BASE}/industrialural.webp`,
      },
      {
        title: {
          ru: "Путешествия по&nbsp;Свердловской области",
          en: "Trips Across the Sverdlovsk Region",
        },
        text: {
          ru: "Автобусные поездки за&nbsp;пределы Екатеринбурга, чтобы увидеть Средний Урал во&nbsp;всём его многообразии. Это и&nbsp;крупнейший музейный комплекс Верхней Пышмы, где история страны раскрывается через коллекции автомобилей, самолётов и&nbsp;бронетехники, и&nbsp;исторический город-завод Сысерть, где индустриальное наследие соединяется с&nbsp;культурой и&nbsp;современной жизнью.",
          en: "Take a&nbsp;bus trip beyond Ekaterinburg to&nbsp;discover the diversity of&nbsp;the Middle Urals. Destinations include the largest museum complex in&nbsp;Verkhnyaya Pyshma, where the country&rsquo;s history comes to&nbsp;life through collections of&nbsp;automobiles, aircraft, and armored vehicles, as&nbsp;well as&nbsp;the historic industrial town of&nbsp;Sysert, where industrial heritage meets contemporary life and culture.",
        },
        cover: `${PROGRAM_IMG_BASE}/journeyural.webp`,
      },
    ],
  },

  {
    title: {
      ru: "Объединяющая программа",
      en: "Team Building Track",
    },
    sessions: [
      {
        title: {
          ru: "&laquo;Сказки мира&raquo;",
          en: "Tales of&nbsp;the World",
        },
        text: {
          ru: "Игровой командообразующий формат, где мифы и&nbsp;легенды народов становятся основой для межкультурного взаимодействия. Команды выполняют &laquo;сказочные&raquo; задания, собирают артефакты и&nbsp;знакомятся с&nbsp;культурными кодами разных стран.",
          en: "A&nbsp;team-building game format where myths and legends from different cultures become the basis for intercultural interaction. Teams complete &ldquo;fairy tale&rdquo; tasks, collect artifacts, and discover the cultural codes of&nbsp;different countries.",
        },
        cover: `${PROGRAM_IMG_BASE}/tales.webp`,
      },
      {
        title: {
          ru: "Чемпионаты",
          en: "Championships",
        },
        text: {
          ru: "Соревнования, где участники пробуют себя в&nbsp;новых технологиях, создают нейроконтент и&nbsp;учатся распознавать недостоверную информацию. Это про командный дух и&nbsp;возможность первыми освоить&nbsp;то, что завтра станет частью нашей жизни.",
          en: "Competitions where participants explore new technologies, create neural content, and learn to&nbsp;identify misinformation. It&rsquo;s all about team spirit and the opportunity to&nbsp;be&nbsp;among the first to&nbsp;master what will become part of&nbsp;our everyday lives tomorrow.",
        },
        cover: `${PROGRAM_IMG_BASE}/championships.webp`,
      },
      {
        title: {
          ru: "Игры",
          en: "Games",
        },
        text: {
          ru: "Ролевые и&nbsp;тематические игровые форматы, в&nbsp;которых каждый может прокачать навыки и&nbsp;найти единомышленников. Здесь легко учиться, общаться и&nbsp;открывать в&nbsp;себе&nbsp;то, о&nbsp;чём вы&nbsp;даже не&nbsp;подозревали.",
          en: "Role-playing and themed game formats where you can upgrade your skills and meet like-minded people. It&rsquo;s an&nbsp;easy way to&nbsp;learn, connect, and discover abilities you never knew you had.",
        },
        cover: `${PROGRAM_IMG_BASE}/games.webp`,
      },
    ],
  },
  {
    title: {
      ru: "Детская программа",
      en: "Children's program",
    },
    sessions: [
      {
        title: {
          ru: "Открытие Детской программы: Шоу &laquo;Голоса Большого мира&raquo; на&nbsp;МФМ-2026",
          en: "Opening of the Children&rsquo;s Program: Voices of the Big World Show at the IFY&nbsp;&mdash; 2026",
        },
        text: {
          ru: "Тысяча подростков, более 100 стран. Открытие Детской программы МФМ-2026&nbsp;&mdash; момент, когда ты&nbsp;чувствуешь: мир огромен, но&nbsp;в&nbsp;нём есть место для&nbsp;тебя. Первые знакомства, первые идеи, первый шаг к&nbsp;большему. Узнай программу, вдохновляйся и&nbsp;начни свой путь. Пусть твой голос станет частью &laquo;Большого мира&raquo;.",
          en: "1,000 teenagers from more than 100 countries. The opening of the IFY&nbsp;&mdash; 2026 Children&rsquo;s Program is a moment when you realize that the world is huge, and there is a place for you in it. First connections, first ideas, and the first step toward something bigger. Discover the program, get inspired, and start your journey. Let your voice become part of the &ldquo;Big World.&rdquo;",
        },
        cover: `${PROGRAM_IMG_BASE}/voices-of-big-world.webp`,
      },
      {
        title: {
          ru: "Экскурсионная программа. Знакомство с&nbsp;Екатеринбургом и&nbsp;выездные форматы",
          en: "Excursion Program. Discover Ekaterinburg and Travel Beyond the City",
        },
        text: {
          ru: "Екатеринбург&nbsp;&mdash; город-перекрёсток, где Европа встречается с&nbsp;Азией. Здесь прошлое не&nbsp;мешает будущему: Плотинка, уличные музыканты, художники&nbsp;&mdash; и&nbsp;ты&nbsp;чувствуешь этот ритм. Для&nbsp;юных гостей&nbsp;&mdash; маршруты и&nbsp;квесты, чтобы исследовать город в&nbsp;игре. Екатеринбург ждёт тебя своей историей и&nbsp;открытостью.",
          en: "Ekaterinburg is a crossroads where Europe meets Asia. Here, the past doesn&rsquo;t stand in the way of the future. You can feel the city&rsquo;s rhythm everywhere, from the Dam to street musicians to artists. Young guests can explore the city through routes and quests. Ekaterinburg is waiting to welcome you with its history and openness.",
        },
        cover: `${PROGRAM_IMG_BASE}/excursion.webp`,
      },
      {
        title: {
          ru: "Создание проектов в&nbsp;60 лабораториях и&nbsp;мастерских по&nbsp;8 направлениям МФМ-2026",
          en: "Create Projects in 60 Labs and Workshops Across Eight IFY&nbsp;&mdash; 2026 Areas",
        },
        text: {
          ru: "60 лабораторий и&nbsp;мастерских по&nbsp;8 направлениям: наука, технологии, инженерия, искусство, спорт, предпринимательство, медиа, социальное проектирование. Работа с&nbsp;наставниками ведущих компаний России. Решай задачи, создавай проекты, осваивай технологии. Пространство для&nbsp;экспериментов, открытий и&nbsp;старта в&nbsp;профессию.",
          en: "60 labs and workshops across eight areas: science, technology, engineering, art, sports, entrepreneurship, media, and social innovation. Work with mentors from leading Russian companies. Solve problems, create projects, and explore new technologies. It's a space for experimentation, discovery, and taking your first steps toward a career.",
        },
        cover: `${PROGRAM_IMG_BASE}/labs.webp`,
      },
      {
        title: {
          ru: "Шоу &laquo;Только в&nbsp;России. Движение Первых&raquo;",
          en: "Only in Russia. Movement of the First Show",
        },
        text: {
          ru: "Шоу&nbsp;&mdash; о&nbsp;душе, выборе и&nbsp;силе творить во&nbsp;благо. Ты&nbsp;почувствуешь: быть частью Движения Первых&nbsp;&mdash; значит становиться сильнее вместе. Песни, артисты, традиции и&nbsp;современность в&nbsp;унисон. История о&nbsp;любви к&nbsp;Родине, уважении к&nbsp;прошлому и&nbsp;смелости строить будущее. Стань частью большого, яркого, настоящего.",
          en: "It's a show about soul, choice, and the power to create for the good of others. You&rsquo;ll feel that being part of the Movement of the First means growing stronger together. Songs, artists, traditions, and modernity come together in harmony. It's a story about love for your homeland, respect for the past, and the courage to build the future. Become part of something big, bright, and real.",
        },
        cover: `${PROGRAM_IMG_BASE}/only-in-russia.webp`,
      },
      {
        title: {
          ru: "Единство народов. Фестиваль Игр Народов Мира: национальные костюмы, русская ярмарка и&nbsp;большой международный хоровод",
          en: "Unity of Peoples. World Games Festival: Traditional Costumes, Russian Fair, and Grand International Circle Dance",
        },
        text: {
          ru: "Фестиваль игр народов мира&nbsp;&mdash; праздник единства и&nbsp;культурного разнообразия. Интерактивные площадки: национальные костюмы, традиционная кухня, народные игры, мастер-классы, фотозоны, русская ярмарка с&nbsp;сувенирами и&nbsp;угощениями. Кульминация&nbsp;&mdash; большой международный хоровод, символ единства, дружбы и&nbsp;взаимопонимания между народами.",
          en: "The World Games Festival is a celebration of unity and cultural diversity. Explore interactive spaces featuring traditional costumes, local cuisine, folk games, workshops, photo zones, and a Russian fair with souvenirs and treats. The highlight is a grand international circle dance, a symbol of unity, friendship, and mutual understanding among peoples.",
        },
        cover: `${PROGRAM_IMG_BASE}/unity-of-peoples.webp`,
      },
      {
        title: {
          ru: "Составление карты желаний",
          en: "Creating Your Vision Board",
        },
        text: {
          ru: "Каждый участник создаст индивидуальную &laquo;карту желаний и&nbsp;планов по&nbsp;развитию&raquo;&nbsp;&mdash; маршрут личностного и&nbsp;профессионального роста. Стратегическая сессия с&nbsp;наставниками: от&nbsp;целей и&nbsp;ценностей к&nbsp;конкретным шагам, проектам и&nbsp;партнёрствам. Вдохновляющие примеры, поддержка единомышленников и&nbsp;практические инструменты&nbsp;&mdash; основа для&nbsp;движения вперёд.",
          en: "Every participant will create an individual &laquo;vision and development map, &rdquo; a roadmap for personal and professional growth. During a strategic session with mentors, you&rsquo;ll turn your goals and values into concrete steps, projects, and partnerships. Inspiring examples, support from like-minded people, and practical tools will help you move forward.",
        },
        cover: `${PROGRAM_IMG_BASE}/vision-board.webp`,
      },
      {
        title: {
          ru: "Научный городок &laquo;Город будущего&raquo;",
          en: "City of the Future Science Campus",
        },
        text: {
          ru: "Научный городок &laquo;Город будущего&raquo;&nbsp;&mdash; пространство, где участники прикоснутся к&nbsp;технологиям завтрашнего&nbsp;дня. Павильоны: космос, робототехника, ИИ, новые материалы. Эксперименты, мастер-классы, виртуальные туры. Ты&nbsp;увидишь, как&nbsp;наука меняет мир, и&nbsp;поймёшь, как&nbsp;стать частью этих перемен.",
          en: "The City of the Future Science Campus is a space where participants can get hands-on with the technologies of tomorrow. Explore pavilions dedicated to space, robotics, AI, and new materials. Take part in experiments and workshops and go on virtual tours. See how science is changing the world and discover how you can be part of that change.",
        },
        cover: `${PROGRAM_IMG_BASE}/science-campus.webp`,
      },
      {
        title: {
          ru: "Партнерство во&nbsp;имя взаимного развития. &laquo;День в&nbsp;семье Первых&raquo;",
          en: "Partnership for Mutual Development. A Day with a Family of the First",
        },
        text: {
          ru: "&laquo;День в&nbsp;семье Первых&raquo;&nbsp;&mdash; уникальная возможность для&nbsp;иностранных участников познакомиться с&nbsp;бытом, традициями и&nbsp;гостеприимством российских семей. Участники разделят домашний уют, попробуют традиционную кухню, примут участие в&nbsp;совместных активностях. Этот формат укрепляет дружеские связи, развивает взаимопонимание и&nbsp;оставляет яркие воспоминания.",
          en: "A Day with a Family of the First is a unique opportunity for international participants to experience the everyday life, traditions, and hospitality of Russian families. Share the warmth of a family home, try traditional food, and take part in activities together. This experience builds friendships, fosters mutual understanding, and creates vivid memories.",
        },
        cover: `${PROGRAM_IMG_BASE}/partnership.webp`,
      },
      {
        title: {
          ru: "Этнографическая деревня",
          en: "Ethnographic Village",
        },
        text: {
          ru: "Этнографическая деревня&nbsp;&mdash; интерактивное пространство для&nbsp;путешествия по&nbsp;культурам России и&nbsp;мира. Тематические подворья: быт, ремёсла, костюмы, кухня, фольклор, мастер-классы, народные игры и&nbsp;обряды. Место живого диалога культур, где можно узнать новое и&nbsp;поделиться своими традициями. Атмосфера уважения и&nbsp;единства в&nbsp;многообразии.",
          en: "The Ethnographic Village is an interactive space for exploring the cultures of Russia and the world. Themed courtyards showcase everyday life, crafts, traditional costumes, cuisine, folklore, workshops, folk games, and rituals. It is a place for a genuine cultural dialogue where you can discover something new and share your own traditions. An atmosphere of respect and unity is in diversity.",
        },
        cover: `${PROGRAM_IMG_BASE}/etnographic-village.webp`,
      },
      {
        title: {
          ru: "Спортивный городок. Фестиваль спорта",
          en: "Sports Town. Sports Festival",
        },
        text: {
          ru: "Спортивный городок&nbsp;&mdash; энергия, движение и&nbsp;командный&nbsp;дух. Соревнования, эстафеты, мастер-классы от&nbsp;звёзд спорта, площадки для&nbsp;уличной культуры, фитнеса и&nbsp;ЗОЖ. Главное&nbsp;&mdash; уважение, взаимоподдержка и&nbsp;радость движения. Спорт&nbsp;&mdash; универсальный язык дружбы. Сдай ГТО Первых: подтягивания, бег, прыжки, гибкость. Узнай свой уровень и&nbsp;точки роста.",
          en: "The Sports Town is all about energy, movement, and team spirit. Take part in competitions and relay races, join workshops led by sports stars, and explore spaces dedicated to street culture, fitness, and healthy lifestyle. Above all, it&rsquo;s about respect, mutual support, and the joy of movement. Sport is a universal language of friendship. Take the GTO of the First fitness test, which includes pull-ups, running, jumping, and flexibility exercises. Find out your level and areas for improvement.",
        },
        cover: `${PROGRAM_IMG_BASE}/sports-town.webp`,
      },
      {
        title: {
          ru: "Программа гостеприимства",
          en: "Hospitality Program",
        },
        text: {
          ru: "Программа гостеприимства&nbsp;&mdash; пространство открытости и&nbsp;дружбы. &laquo;Международная библиотека культур&raquo;: литература, искусство, чтения, встречи с&nbsp;писателями. &laquo;Почта будущего&raquo;: письма сверстникам из&nbsp;других стран. Кульминация&nbsp;&mdash; Международный хоровод дружбы, символ единства народов. Фестиваль становится личным опытом дружбы, взаимопонимания и&nbsp;единства.",
          en: "The Hospitality Program is a space for openness and friendship. The International Library of Cultures features literature, art, readings, and meetings with writers. With the Future Mail, you can write letters to peers from other countries. The highlight is the International Friendship Circle Dance, which symbolizes unity among peoples. The Festival provides a personal experience of friendship, mutual understanding, and unity.",
        },
        cover: `${PROGRAM_IMG_BASE}/hospitality-program.webp`,
      },
    ],
  },
]

export const MFM_VOLUNTEER_REG_URL = "https://dobro.ru/event/11434992"

export const gtagCb: Parameters<Gtag>[0] = (id, gtag) => {
  gtag("event", "conversion", {
    send_to: id,
    value: 1.0,
    currency: "USD",
  })
}

export function getIsRegClosed (): boolean {
  return Date.now() >= new Date("2026-06-01T00:00:00+03:00").getTime()
}

const CITIZEN_REG_FINISH = new Date("2026-08-10T21:59:59+03:00").getTime()

export function getIsCitizenRegClosed (): boolean {
  return Date.now() > CITIZEN_REG_FINISH
}

const CONTEST_INVITE_FINISH = new Date("2026-09-17T23:59:59+03:00").getTime()

export function getIsContestInviteValid (token: unknown): boolean {
  return token === MFM_CONTEST_INVITE_TOKEN &&
    Date.now() < CONTEST_INVITE_FINISH
}

type ExtendedRegistrationAlias = "guest" | "partner" | "participantEscort" | "guide" | "media" | "expert" | "honoredGuest" | "visitor" | "attache"

interface ExtendedRegistrationStatus {
  alias: ExtendedRegistrationAlias
  registrationFinish: number
}

const EXTENDED_REG_FINISH_MAIN = new Date("2026-08-28T23:59:59+03:00").getTime()
const EXTENDED_REG_FINISH_MEDIA = new Date("2026-07-17T23:59:59+03:00").getTime()
const EXTENDED_REG_FINISH_EXTRA = new Date("2026-09-16T23:59:59+03:00").getTime()

export const EXTENDED_REG_FINISH_PARTICIPANT = new Date("2026-09-14T23:59:59+03:00").getTime()
export const EXTENDED_REG_PARTICIPANT_NEW_USER_DATE = new Date("2026-08-31T00:00:00+03:00").getTime()

const EXTENDED_REGISTRATION_STATUSES: ExtendedRegistrationStatus[] = [
  {
    alias: "guest",
    registrationFinish: EXTENDED_REG_FINISH_EXTRA,
  },
  {
    alias: "partner",
    registrationFinish: EXTENDED_REG_FINISH_MAIN,
  },
  {
    alias: "participantEscort",
    registrationFinish: EXTENDED_REG_FINISH_MAIN,
  },
  {
    alias: "guide",
    registrationFinish: EXTENDED_REG_FINISH_EXTRA,
  },
  {
    alias: "media",
    registrationFinish: EXTENDED_REG_FINISH_MEDIA,
  },
  {
    alias: "expert",
    registrationFinish: EXTENDED_REG_FINISH_EXTRA,
  },
  {
    alias: "honoredGuest",
    registrationFinish: EXTENDED_REG_FINISH_EXTRA,
  },
  {
    alias: "visitor",
    registrationFinish: EXTENDED_REG_FINISH_EXTRA,
  },
  {
    alias: "attache",
    registrationFinish: EXTENDED_REG_FINISH_EXTRA,
  },
]

export function getIsExtendedRegistrationOpen (statusAlias: string): boolean {
  const status = EXTENDED_REGISTRATION_STATUSES.find(s => s.alias === statusAlias)
  if (!status) return false

  return Date.now() < status.registrationFinish
}

export function getIsContinueFillAllowed (statusAlias: string): boolean {
  const status = EXTENDED_REGISTRATION_STATUSES.find(s => s.alias === statusAlias)

  if (!status) return false
  return Date.now() < status.registrationFinish
}
